<template>
    <ModalBase
        :name="'borrar-' + abonado.id"
        :title="'Borrar abono de ' + abonado.name + ' ' + abonado.surnames"
        @close="close"
    >
        <div class="tw:space-y-3">
            <div class="tw:flex tw:justify-between tw:py-2 tw:border-b tw:border-gray-100">
                <span class="tw:text-sm tw:font-semibold tw:text-gray-600">Nª de abonado</span>
                <span class="tw:text-sm tw:text-gray-900">{{ abonado.n_abonado }}</span>
            </div>
            <div class="tw:flex tw:justify-between tw:py-2 tw:border-b tw:border-gray-100">
                <span class="tw:text-sm tw:font-semibold tw:text-gray-600">Nombre</span>
                <span class="tw:text-sm tw:text-gray-900">{{ abonado.name }}</span>
            </div>
            <div class="tw:flex tw:justify-between tw:py-2 tw:border-b tw:border-gray-100">
                <span class="tw:text-sm tw:font-semibold tw:text-gray-600">Apellidos</span>
                <span class="tw:text-sm tw:text-gray-900">{{ abonado.surnames }}</span>
            </div>
            <div class="tw:flex tw:justify-between tw:py-2 tw:border-b tw:border-gray-100">
                <span class="tw:text-sm tw:font-semibold tw:text-gray-600">DNI</span>
                <span class="tw:text-sm tw:text-gray-900">{{ abonado.dni }}</span>
            </div>
            <div class="tw:flex tw:justify-between tw:py-2 tw:border-b tw:border-gray-100">
                <span class="tw:text-sm tw:font-semibold tw:text-gray-600">Email</span>
                <span class="tw:text-sm tw:text-gray-900">{{ abonado.email }}</span>
            </div>
            <div class="tw:flex tw:justify-between tw:py-2">
                <span class="tw:text-sm tw:font-semibold tw:text-gray-600">Asiento</span>
                <span class="tw:text-sm tw:text-gray-900 tw:text-right">
                    <template v-if="abonado.tiene_asiento">
                        <strong>Zona:</strong> {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}
                    </template>
                    <template v-else>
                        Sin asiento
                    </template>
                </span>
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end">
                <Button variant="danger" @click="borrarAbonado">SI, BORRAR</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue'
    import store from '@/store'
    import { useToast } from '@/composables/common/useToast'
    import { config } from '@/config'
    import ModalBase from '@/modules/admin/ui/ModalBase'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        abonado: {
            type: Object,
            required: true
        }
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const borrado = ref(false)

    const close = () => {
        emit('close', `borrar-${props.abonado.id}`, borrado.value)
    }

    const borrarAbonado = () => {
        const params = {
            filters: {},
            abonado_id: props.abonado.id
        }

        store.dispatch(config.getVuexAlias('back.abonados.borrar'), params)
            .then(res => {
                borrado.value = true
                toast.success('Abonado borrado')
                close()
            })
            .catch(err => {
                const errorMessage = err.response?.data?.message || 'Error al eliminar abonado'
                toast.error(errorMessage)
                close()
            })
    }
</script>
